// extracted by mini-css-extract-plugin
module.exports = {"header":"text-block-module--header--23Ifw","text":"text-block-module--text--fwQab","wrapper":"text-block-module--wrapper--2afWl"};